import { useEffect } from 'react';
import { useStateContext } from '@veda/dashboard-ui';

/**
 * Imposta il contesto AI per le pagine PPP al mount e lo azzera all'unmount.
 *
 * Il contesto viene letto da AiToolRegistry lato backend per inviare al modello
 * SOLO i tool rilevanti per la pagina corrente, riducendo il consumo di token.
 *
 * @param {string} entita  Identificatore dell'area (es. 'ppp.procedimento', 'ppp.programmazione')
 * @param {object} [extra] Campi aggiuntivi opzionali (es. { id: 4, titolo: 'Xyz' })
 */
export function usePppAiContext(entita, extra = {}) {
  const { setAiContext } = useStateContext();

  useEffect(() => {
    setAiContext({ entita, ...extra });
    return () => setAiContext(null);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entita, JSON.stringify(extra)]);
}
